export const PATHS = {
  admin: {
    root: "/portal/admin",
    login: "/portal/admin/login",
    dashboard: "/portal/admin/dashboard",
    montageApplication: {
      root: "/portal/admin/montage-application",
      detail: {
        root: "/portal/admin/montage-application/detail/:id",
        get: (id: string) => `/portal/admin/montage-application/detail/${id}`,
      },
    },
    servicesProviders: {
      root: "/portal/admin/service-providers",
      application: "/portal/admin/service-providers/application",
      profile: {
        root: `/portal/admin/service-providers/profile/:id`,
        get: (id: string) => `/portal/admin/service-providers/profile/${id}`,
      },
    },
    reservation: {
      root: "/portal/admin/reservation",
      detail: {
        root: "/portal/admin/reservation/:id",
        get: (id: string) => `/portal/admin/reservation/${id}`,
      },
    },
    referance: {
      root: "/portal/admin/referance",
    },
    service: {
      root: "/portal/admin/service",
      profile: { root: "/portal/admin/service/profile" },
      onboarding: "/portal/admin/service/onboarding",
    },
    prospect: {
      root: "/portal/admin/prospect",
    },
  },
  ref: {
    root: `/portal/ref/:token`,
    login: "/portal/reference/login",
  },
  forgotPassword: "/portal/forgot-password/:token",
};
